/**
 * 토크의 타입. 나레이션/전지적/화자
 */
export enum TalkType {
  Narration = 'narration',
  Omniscient = 'omniscient',
  Talker = 'talker',
  None = 'none',
}
